"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_DELTA = void 0;
exports.getLabelPoint = getLabelPoint;
exports.drawableMarkerCreateBinding = drawableMarkerCreateBinding;
const core_api_1 = require("@ikegps/core-api");
const id_1 = require("../../id");
const model_1 = require("../../model");
const draw_state_1 = require("../draw.state");
const label_draw_svg_1 = require("../drawable/label.draw.svg");
const util_draw_svg_1 = require("../drawable/util.draw.svg");
const util_1 = require("../util");
exports.LABEL_DELTA = { x: 0, y: 50 };
function getLabelPoint(uiScale, resolution, marker) {
    const labelPoint = { x: resolution.width * 0.75, y: marker.y };
    return (0, util_1.movePoint)(labelPoint, exports.LABEL_DELTA, resolution, {
        width: label_draw_svg_1.LabelSVGDraw.Size.width * uiScale,
        height: label_draw_svg_1.LabelSVGDraw.height(1) * uiScale,
    });
}
function createMarkerAt(dc, markerPoint, type = core_api_1.MarkerType.NONE) {
    const labelPoint = getLabelPoint(dc.state.scale, dc.capture.resolution, markerPoint);
    const { marker } = model_1.CollectionModelDrawableMarker.createWithLabel(dc.drawState, markerPoint, labelPoint, id_1.IkeId.generate(), type);
    dc.state.setSelected(marker.id, util_draw_svg_1.IkeDrawLabel.LABEL);
    return marker.id;
}
function drawableMarkerCreateBinding(dc, evt) {
    if (dc.state.tool === draw_state_1.IkeDrawTool.BASE) {
        const drawableId = createMarkerAt(dc, evt.center, core_api_1.MarkerType.BASE);
        const drawable = dc.drawState.getDrawable(drawableId);
        // Base Marker's label are shown hard against the left edge
        drawable.label.move(0, drawable.label.y);
        dc.state.setTool(null);
        dc.state.setCrosshair(false);
        return;
    }
    if (evt.drawableId == null) {
        evt.drawableId = createMarkerAt(dc, evt.center);
    }
    const linkFieldIds = dc.state.linkFieldIds;
    if (linkFieldIds.length > 0) {
        const drawable = dc.drawState.getDrawable(evt.drawableId);
        if (!model_1.CollectionModelDrawableMarker.isNone(drawable)) {
            return;
        }
        for (const linkFieldId of linkFieldIds) {
            const field = dc.collection.findField(linkFieldId);
            if (!field) {
                throw new Error(`Unable to find field: ${linkFieldId}`);
            }
            if (field instanceof model_1.CollectionModelFieldVerticalSeparation) {
                field.Mutator.drawable(drawable);
                drawable.label.linkVerticalSeparation(field);
            }
            else {
                field.Mutator.drawable(drawable);
            }
        }
        dc.state.setLinkFields(null);
        dc.state.setSelected(drawable.id, util_draw_svg_1.IkeDrawLabel.LABEL);
        drawable.approveInsightFlag();
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
}
//# sourceMappingURL=marker.create.binding.js.map